<template>
<div>

  <b-row class="m-b-30">
    <b-col>
      <h2>Take DHL Actions
        <b-dropdown id="dropdown-1" text="Controls" size="xs" class="m-md-2">
          <b-dropdown-item @click="removeOrderRecordsFromStore">Remove All</b-dropdown-item>
        </b-dropdown>
      </h2>
    </b-col>
  </b-row>
  <div v-if="finalShippingOrdersForApiCall.length > 0">
    <section v-for="store in stores" :key="store.id" class="m-b-30">
      <h4>{{ store.text }}</h4>
      <div class="card text-left">
        <div class="card-body">
          <div class="custom-tag custom-tag-color m-b-5 m-r-5">
            <span>Total: {{ store.orders.length }}</span>
          </div>
          <div class="custom-tag m-b-5 m-r-5" v-for="order in store.orders" :key="order.id">
            <span>{{ order.order_no }}</span>

            <i class="fa fa-minus-circle" aria-hidden="true" @click="removeFromList(order.id)"></i>
          </div>
        </div>
      </div>
    </section>
    <b-button size="lg" block variant="info" @click.prevent="sendOrdersForShipping">CREATE DHL SHIPPING</b-button>
  </div>
  <div v-else>
    <b-alert show>No orders added for dhl actions. Go to orders and select some for the taking some actions. The limit is 100</b-alert>
  </div>

</div>
</template>

<script>
import StoreService from '../../services/store.service';
import ShippingsService from '../../services/shippings.service';
import EventBus from '../../EventBus';
export default {
  data() {
    return {
      stores: [],
    }
  },
  mounted() {
    this.fetchStores();
  },
  methods: {
    fetchStores() {
      if (this.finalShippingOrdersForApiCall.length > 0) {
        StoreService.fetchStores().then(response => {
            let company_stores = response.data.data.map(store => {
              return JSON.parse(JSON.stringify({
                value: store.id,
                text: store.identifier,
                orders: []
              }))
            });
            this.stores = this.stores.concat(company_stores);

            this.segragateOrders();
          })
          .catch(errors => console.log(errors));
      }
    },
    segragateOrders() {
      this.stores.forEach(store => {
        store.orders = this.finalShippingOrdersForApiCall.filter(order => {
          return store.value == order.shopify_store_id
        });
      });
    },
    removeFromList(id) {
      console.log('Remove from shipment', id);
      let orderId = [id];
      this.$store.dispatch('orders/removeFromOrdersShipping', orderId)
        .then(() => {
          console.log('Order removed for shipping to DHL')
          this.segragateOrders();
        })
    },
    sendOrdersForShipping() {
      EventBus.$emit('should-show-loader', true)
      ShippingsService.createShippingRecordsInDhl(this.finalShippingOrdersForApiCall)
        .then(response => {
          // do something with the response
          console.log('Add to shipping data', response.data);
          this.$toasted.show(response.data.responseStatus.messageDetails[0].messageDetail, {
            type: 'success',
            action: {
              text: "Cancel",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
            duration: 5000,
          });
          this.removeOrderRecordsFromStore();
        })
        .catch(errors => {
          console.log("Errors", errors.response.data)
          this.$toasted.show(errors.response.data.message, {
            type: "error",
            action: {
              text: "Cancel",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
            duration: 5000,
          });
        })
        .then(() => {
          EventBus.$emit('should-show-loader', false)
        })

    },
    removeOrderRecordsFromStore() {
      this.$store.dispatch('orders/removeAllFromOrdersShipping')
        .then(() => {
          console.log('All removed');
        })
    }
  },
  computed: {
    finalShippingOrdersForApiCall() {
      return this.$store.state.orders.ordersForShipping;
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-tag {
  display: inline-block;
  padding: 5px 30px;
  border-radius: 20px;
  background-color: rgb(32, 212, 92);
  border: 1px solid rgb(28, 189, 82);
  color: #fff;
  position: relative;

  &.custom-tag-color {
    border: 1px solid rgb(255, 72, 0);
    background-color: rgb(255, 115, 0);
  }

  span {
    cursor: pointer;
  }

  i {
    position: absolute;
    right: 10px;
    top: 8px;
    cursor: pointer;

    &:hover {
      color: rgb(255, 62, 62);
    }
  }
}
</style>
